var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnlyLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 847.75 244.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: red;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 144.28,
    width: 61.2,
    height: 99.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.25 144.17 104.16 243.52 165.36 243.52 122.45 144.17 61.25 144.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.09,142A66.69,66.69,0,0,0,99,8.64c-1.87,0-3.72.07-5.55.23H.06v61.2h99v-.15h.11v0a5.57,5.57,0,0,1,0,11.11v0h-.11V81H.06v61.21h99Z",
    transform: "translate(0 -8.64)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.64,219.22a164.51,164.51,0,0,0,2,27.17H291.92c-1.15-3.44-2-9.73-2.58-22-4.86,10.59-17.44,25.46-46.9,25.46-33.18,0-47.48-21.45-47.48-42.9,0-31.46,24.31-45.76,67.21-45.76h27.17V146.57c0-14.3-4.29-33.46-36.89-33.46-28.89,0-33.18,15.16-36.32,26.89h-14.3c1.71-15.73,11.44-40,50.91-40,32.6,0,50.9,13.72,50.9,45.18Zm-14-45.76h-28c-31.74,0-51.48,8.29-51.48,32.89,0,18,12.87,30.31,32.89,30.31,40.9,0,46.62-27.17,46.62-58.06Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.09,35.61V205.2c0,13.73,0,26.88.28,41.19H450.65c-.58-3.44-.86-16.88-.86-24-7.15,17.45-23.17,27.46-48.05,27.46-37.18,0-59.49-30.32-59.49-73.22,0-44,24.31-76.64,63.21-76.64,28.6,0,40,12.29,44.33,21.45V35.61ZM357.41,176c0,39.18,20.31,60.35,44.9,60.35,37.75,0,48.05-26,48.05-64.93,0-36.89-8.87-58-45.47-58C376.57,113.4,357.41,136,357.41,176Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.85,46.19H576.2c54.91,0,92.95,38.32,92.95,98.38,0,59.77-37.18,101.82-93.24,101.82H509.85Zm15.44,185.89h48.33c52.91,0,78.94-37.17,78.94-86.65,0-44-23.45-84.94-78.94-84.94H525.29Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708.9,46.19h69.78c38.33,0,58.92,20.3,58.92,49.19,0,23.74-14.3,39.18-30.89,43.76,14.3,4,38,18,38,49.47,0,40-30,57.78-64.92,57.78H708.9Zm64.64,86.08c34.6,0,47.76-12.87,47.76-36,0-19.74-13.73-35.75-41.76-35.75H724.06v71.78Zm-49.48,99.81H780.4c26.31,0,48.33-13.15,48.33-42.61,0-25.45-16.3-42.9-56.62-42.9H724.06Z",
    transform: "translate(0 -8.64)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyLight);
export default __webpack_public_path__ + "static/media/logoOnly-light.c8c5cb2b81134246c6e744faa11d01c1.svg";
export { ForwardRef as ReactComponent };